import Api from "../../config/ApiConfig";
import { IUser } from "./types";

const apiUrls = {
  getUsers: "api/v1/users",
  searchOverrides: "api/v1/searches/overrides",
  getOverrides: "api/v1/overrides"
};

export const getGroupUsers = (adGroup: string) => {
  return Api.get<IUser[]>(apiUrls.getUsers + "?adgroup=" + adGroup);
}

export const getParam = (param: string[] | undefined, paramType: string) => {
  let str: string = '';
  if (param && param?.length > 0) str = `&${paramType}=${param}`;
  return str;
}
